define(['./commonRoutingParameters', '../utils', '../postValidators', '../validators', 'common/parameterApplications'],
    function(commonRoutingParameters, utils, postValidators, validators, parameterApplications) {
        var fields = {

        /**
         * Point from which the range calculation should start.
         *
         * @method origin
         * @chainable
         * @param {String} origin Point from which the range calculation should start.
         * @throws {TypeError} if the given argument cannot be converted to a valid value
         * @return {reachableRange|String} Method returns the service instance allowing chaining or current value if
         *     argument is omitted.
         */
            origin: {
                validator: validators.routingLocation,
                application: parameterApplications.PATH
            },

            /**
         * Getter and setter for fuelBudgetInLiters.
         *
         * @method fuelBudgetInLiters
         * @chainable
         * @param {Number} fuelBudgetInLiters Fuel budget in liters that
         *     determines maximal range which can be travelled using the specified
         *     Combustion Consumption Model. Required if _vehicleEngineType_ is
         *     _combustion_.
         * @throws {TypeError} if the given argument cannot be converted to a
         *     valid value
         * @return {String} Method returns the service instance allowing chaining or current value if
         *     argument is omitted.
         */
            fuelBudgetInLiters: {
                postValidator: [
                    postValidators.requiredBudget,
                    postValidators.requiredWithSpecificEngineType,
                    postValidators.notCommon
                ]
            },

            /**
         * Getter and setter for energyBudgetInkWh.
         *
         * @method energyBudgetInkWh
         * @chainable
         * @param {Number} energyBudgetInkWh  Electric energy budget in
         * kilowatt hours (kWh) that determines maximal range which can be
         * travelled using the specified Electric Consumption Model.
         * @throws {TypeError} if the given argument cannot be converted to a
         *     valid value
         * @return {String} Method returns the service instance allowing chaining or current value if
         *     argument is omitted.
         */
            energyBudgetInkWh: {
                postValidator: [
                    postValidators.requiredBudget,
                    postValidators.requiredWithSpecificEngineType,
                    postValidators.notCommon
                ]
            },

            /**
         * Getter and setter for timeBudgetInSec.
         *
         * @method timeBudgetInSec
         * @chainable
         * @param {Number} timeBudgetInSec  Time budget in seconds that determines maximal
         * range which can be travelled using driving time.
         * The consumption parameters will only affect eco-routes and thereby indirectly the driving time.
         * @throws {TypeError} if the given argument cannot be converted to a
         *     valid value
         * @return {String} Method returns the service instance allowing chaining or current value if
         *     argument is omitted.
         */
            timeBudgetInSec: {
                postValidator: [
                    postValidators.requiredBudget,
                    postValidators.notCommon
                ]
            }

        };

        fields = utils.extend(fields, commonRoutingParameters);

        return function(fieldsToSkip) {
            var result = utils.clone(fields);
            if (fieldsToSkip instanceof Array) {
                fieldsToSkip.forEach(function(field) {
                    delete result[field];
                });
            }

            return result;
        };

    });



// WEBPACK FOOTER //
// ./services/routing/reachableRangeParameters.js